import React from 'react';
import pokemonIcon from './pokemon_icon.png';
import trainersIcon from './trainers_icon.png';
import energyIcon from './energy_icon.png';
import promosIcon from './promos_icon.png';
import setsIcon from './sets_icon.png';
import artistIcon from './artist_icon.png';

// Types that use an image asset instead of an inline SVG path. Image icons
// don't follow currentColor, so TypeRail.css inverts them on the active
// (dark) button to keep them visible.
const IMAGES = {
    pokemon: pokemonIcon,
    trainers: trainersIcon,
    energy: energyIcon,
    promos: promosIcon,
    sets: setsIcon,
    artist: artistIcon,
};

// Base rendered size (px) for image icons, plus per-icon multipliers so each
// PNG fills the rail circle by a similar amount despite different internal
// whitespace/aspect. Bump a value to make that one icon bigger.
const ICON_BASE = 24;
const SCALES = {
    artist: 1.3,
    promos: 1.2,
    sets: 1.25,
};

// Simple original line glyphs per type (droplet, flame, bolt, …).
// Deliberately generic shapes — not the official TCG energy symbols.
const PATHS = {
    water: <path d="M12 3c3 4.3 6 7.4 6 10.8A6 6 0 1 1 6 13.8C6 10.4 9 7.3 12 3z" />,
    fire: <path d="M12 3c.8 2.6-.2 4.2-1.6 6C9 10.8 8 12.4 8 14.6A4.2 4.2 0 0 0 16.4 15c0-1.8-.9-3.2-1.9-4.6 1.9.7 3.8-.7 3-4.2-1.6.9-2.4-.9-5.5-3.2z" />,
    electric: <path d="M13 2 5 14h5l-1 8 8-12h-5l1-8z" />,
    psychic: <path d="M12 12a2 2 0 1 0 2 2 4 4 0 1 0-4-4 6.5 6.5 0 1 0 6.5 6.5" fill="none" strokeWidth="2" strokeLinecap="round" stroke="currentColor" />,
    dragon: <path d="M6 19c0-7.5 4.5-11.5 11-13.5-1.2 2.8-.9 4.6 1 6.4-3.2.2-4.6 1.5-4.6 4.3 0 2.1-2.8 2.8-7.4 2.8z" />,
    fairy: <path d="M12 3l2 7 7 2-7 2-2 7-2-7-7-2 7-2 2-7z" />,
    dark: <path d="M20 14.5A8.6 8.6 0 0 1 9.5 4 8.6 8.6 0 1 0 20 14.5z" />,
    metal: <path d="M12 3.2 18.8 7v7.8L12 18.6 5.2 14.8V7L12 3.2z" fill="none" strokeWidth="2.2" strokeLinejoin="round" stroke="currentColor" />,
    colorless: <circle cx="12" cy="12" r="7.5" fill="none" strokeWidth="2.4" stroke="currentColor" />,
    fighting: <path d="M12 2l1.7 5 5-2-2 5 5.3 2-5.3 2 2 5-5-2-1.7 5-1.7-5-5 2 2-5L2 12l5.3-2-2-5 5 2 1.7-5z" />,
    grass: <path d="M5 19C5 9.5 12.5 4.5 20 4.5c0 8-4 13.5-12 14.5 2.2-4.8 5-7.8 8-9.8-5 1.2-8.2 4.2-11 9.8z" />,
};

const TypeIcon = ({ type, size = 20 }) => {
    if (IMAGES[type]) {
        const dim = Math.round(ICON_BASE * (SCALES[type] || 1));
        return (
            <img
                className="gh-typeicon-img"
                src={IMAGES[type]}
                alt=""
                aria-hidden="true"
                style={{ width: dim, height: dim }}
            />
        );
    }
    return (
        <svg
            viewBox="0 0 24 24"
            width={size}
            height={size}
            fill="currentColor"
            aria-hidden="true"
            focusable="false"
        >
            {PATHS[type] || PATHS.colorless}
        </svg>
    );
};

export default TypeIcon;
